export default __webpack_public_path__ + "static/media/3 Weeks of Exclusive V1 Deals_2111_1012_2025.f6f02253.xlsx";